export const FacebookUrl = "https://www.facebook.com/scmp";
export const InstagramUrl = "https://www.instagram.com/scmpnews";
export const LinkedinUrl = "https://www.linkedin.com/company/south-china-morning-post";
export const TwitterUrl = "https://www.twitter.com/scmpnews";
export const YoutubeUrl = "https://www.youtube.com/southchinamorningpost";
